import React, { Dispatch, SetStateAction } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { generateResponsiveStyle } from "../utils/modalStyle";

type props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    func: () => void;
};

const ResendCredsWarning = ({ open, setOpen, func }: props) => {
    const style = generateResponsiveStyle();

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="modal_body logout_body">
                    <CloseIcon className="cross_icn_logout" onClick={() => setOpen(false)} />
                    <Typography
                        id="modal-modal-title"
                        component="h2"
                    >
                        Are you sure, you want to resend credential to this user?
                    </Typography>
                    <div className="form_btn">
                        <Button
                            className="btn btn_primary"
                            onClick={() => {
                                setOpen(false);
                                func();
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            className="btn btn_secondary"
                            onClick={() => setOpen(false)}
                        >
                            No
                        </Button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default ResendCredsWarning;
